import { ShopModal } from './ShopModal';
import { PantsuModal } from './PantsuModal';
import { UpgradeModal } from './UpgradeModal';
import { RingModal } from './RingModal';
import { ItemConfirmModal } from './ItemConfirmModal';
import { ItemTargetWaifuModal } from './ItemTargetWaifuModal';
import { AutobuyItemModal } from './AutobuyItemModal';
import { AvatarOverlay } from '@/components/player/AvatarOverlay';

export function ModalRoot() {
  return (
    <>
      <ShopModal />
      <PantsuModal />
      <UpgradeModal kind="weapon" />
      <UpgradeModal kind="armor" />
      <RingModal />
      <ItemConfirmModal />
      <ItemTargetWaifuModal />
      <AutobuyItemModal />
      <AvatarOverlay />
    </>
  );
}
